<router-outlet></router-outlet>
<ctx-svg-definitions></ctx-svg-definitions>
